import { LIST_DATASOURCE_TYPE } from "../constants";
import { FieldTypes } from "./field.types";
import { Field, FormModel } from "./form.model";

export function registerFieldModels() {
  FormModel.registerModel(TextField);
  FormModel.registerModel(TextareaField);
  FormModel.registerModel(NumberField);
  FormModel.registerModel(CurrencyField);
  FormModel.registerModel(DateField);
  FormModel.registerModel(DateTimeField);
  FormModel.registerModel(EmailField);
  FormModel.registerModel(BooleanField);
  FormModel.registerModel(ImageField);
  FormModel.registerModel(SelectField);
  FormModel.registerModel(MultiselectField);
  FormModel.registerModel(SliderField);
  FormModel.registerModel(UserField);
  FormModel.registerModel(MultiUserField);
  FormModel.registerModel(UserAndGroupField);
  FormModel.registerModel(ReferenceField);
  FormModel.registerModel(StarRatingField);
  FormModel.registerModel(AttachmentField);
  FormModel.registerModel(SmartAttachmentField);
  FormModel.registerModel(SignatureField);
  FormModel.registerModel(ChecklistField);
  FormModel.registerModel(CheckboxField);
  FormModel.registerModel(AggregationField);
  FormModel.registerModel(SequenceNumberField);
  FormModel.registerModel(RadioField);
  FormModel.registerModel(RemoteLookupField);
  FormModel.registerModel(GeolocationField);
  FormModel.registerModel(ScannerField);
}

export class TextField extends Field {}

TextField.setFieldTypes({
  DefaultValue: FieldTypes.string
});

TextField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::Expression",
  "Field::Event"
]);

export class TextareaField extends Field {}

TextareaField.setFieldTypes({
  AllowFormatting: FieldTypes.boolean
});

TextareaField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class NumberField extends Field {
  validateDecimalPlace(value) {
    if (value && !Number.isInteger(Number(value))) {
      return true;
    } else if (value && parseInt(value, 10) > 10) {
      return true;
    } else if (value && parseInt(value, 10) < 0) {
      return true;
    }
    return false;
  }

  validateProperties() {
    var errors = super.validateProperties();
    var decimalPoint = this.getValue("Decimalpoint");
    if (decimalPoint) {
      var error = this.validateDecimalPlace(decimalPoint);
      error && errors.push("Decimalpoint");
    }

    return errors;
  }
}

NumberField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  Decimalpoint: FieldTypes.string
});

NumberField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::Expression",
  "Field::Event"
]);

export class CurrencyField extends NumberField {
  validateProperties() {
    let errors = super.validateProperties();
    let hasExpression = this.getList("Field", "Expression")[0];
    if (!hasExpression && !this.getValue("CurrencyTypes")?.length > 0) {
      errors.push("CurrencyTypes");
    }

    return errors;
  }
}

CurrencyField.setFieldTypes({
  CurrencyTypes: FieldTypes.array
});

export class DateField extends Field {}

DateField.setFieldTypes({
  DefaultValue: FieldTypes.string
});

DateField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::Expression",
  "Field::Event"
]);

export class DateTimeField extends Field {}

DateTimeField.setFieldTypes({
  DefaultValue: FieldTypes.string
});

DateTimeField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::Expression",
  "Field::Event"
]);

export class EmailField extends Field {}

EmailField.setFieldTypes({
  DefaultValue: FieldTypes.string
});

EmailField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class BooleanField extends Field {}

BooleanField.setFieldTypes({
  DefaultValue: FieldTypes.string
});

BooleanField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class ImageField extends Field {}

ImageField.setOneToManyList(["FieldValidation::Criteria"]);

export class SelectField extends Field {
  validateProperties() {
    var errors = super.validateProperties();
    var datasourceType = this.getValue("DatasourceType");
    var referredList = this.getValue("ReferredList");
    var queryDefinition = this.getList("Field", "QueryDefinition")[0];
    if (!datasourceType && !referredList) {
      errors.push("ReferredList");
    } else if (datasourceType === LIST_DATASOURCE_TYPE.LIST && !referredList) {
      errors.push("ReferredList");
    } else if (
      [LIST_DATASOURCE_TYPE.DATASET, LIST_DATASOURCE_TYPE.DATAFORM].includes(
        datasourceType
      ) &&
      !queryDefinition
    ) {
      errors.push("LHSModel");
    }

    return errors;
  }
}

SelectField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  ReferredList: FieldTypes.string,
  DatasourceType: FieldTypes.string
});

SelectField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::QueryDefinition",
  "Field::Event"
]);

export class MultiselectField extends Field {}

MultiselectField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  ReferredList: FieldTypes.string.isRequired
});

MultiselectField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::Event"
]);

export class SliderField extends Field {
  validateSliderRange() {
    var minValue = Number(this.getValue("MinValue"));
    var maxValue = Number(this.getValue("MaxValue"));

    if (minValue > maxValue || minValue === maxValue) {
      return true;
    }

    return false;
  }

  validateSliderInterval() {
    var minValue = Number(this.getValue("MinValue"));
    var maxValue = Number(this.getValue("MaxValue"));
    var intervalSize = Number(this.getValue("IntervalSize"));

    if (intervalSize > maxValue - minValue || intervalSize === maxValue) {
      return true;
    }

    return false;
  }

  validateProperties() {
    var errors = super.validateProperties();
    var isInValidRange = this.validateSliderRange();
    if (isInValidRange) {
      errors.push("MinValue");
      errors.push("MaxValue");
    }

    var isInValidInterval = this.validateSliderInterval();
    isInValidInterval && errors.push("IntervalSize");

    return errors;
  }
}

SliderField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  MinValue: FieldTypes.string.isRequired,
  MaxValue: FieldTypes.string.isRequired,
  IntervalSize: FieldTypes.string.isRequired
});

SliderField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class UserField extends Field {}

UserField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::QueryDefinition",
  "Field::Event"
]);

export class MultiUserField extends Field {}

MultiUserField.setOneToManyList([
  "FieldValidation::Criteria",
  "Field::QueryDefinition",
  "Field::Event"
]);

export class UserAndGroupField extends Field {}

UserAndGroupField.setOneToManyList(["Field::QueryDefinition"]);

export class ReferenceField extends Field {}

ReferenceField.setOneToManyList(["Field::QueryDefinition", "Field::Event"]);

export class StarRatingField extends Field {}

StarRatingField.setFieldTypes({
  DefaultValue: FieldTypes.string
});

StarRatingField.setOneToManyList(["Field::Event"]);

export class AttachmentField extends Field {}

AttachmentField.setOneToManyList(["FieldValidation::Criteria"]);

export class SmartAttachmentField extends AttachmentField {
  validateProperties() {
    let errors = super.validateProperties();
    let documentType = this.getValue("DocumentType") || "";
    if (!documentType) {
      errors.push("DocumentType");
    }
    return errors;
  }
}

SmartAttachmentField.setFieldTypes({
  DocumentType: FieldTypes.string.isRequired,
  CanAutoFill: FieldTypes.boolean
});

export class SignatureField extends Field {}

SignatureField.setFieldTypes({
  AllowDraw: FieldTypes.boolean
});

export class ChecklistField extends Field {}

ChecklistField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  ReferredList: FieldTypes.string.isRequired,
  CanCreate: FieldTypes.boolean,
  CanDelete: FieldTypes.boolean
});

ChecklistField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class CheckboxField extends Field {}

CheckboxField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  ReferredList: FieldTypes.string.isRequired
});

CheckboxField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class AggregationField extends Field {}

AggregationField.setOneToManyList(["Field::QueryDefinition"]);

export class SequenceNumberField extends Field {}

SequenceNumberField.setOneToManyList(["Field::Property"]);

export class RadioField extends Field {}

RadioField.setFieldTypes({
  DefaultValue: FieldTypes.string,
  ReferredList: FieldTypes.string.isRequired
});

RadioField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

export class RemoteLookupField extends Field {}

RemoteLookupField.setOneToManyList([
  "Field::Property",
  "Field::RemoteLookup",
  "Field::Event"
]);

export class GeolocationField extends Field {
  validateDefaultValue(obj) {
    if (Object.keys(obj).length <= 0) {
      return true;
    }
    return false;
  }

  validateProperties() {
    var errors = super.validateProperties();
    let UseCurrentLocation = this.getValue("UseCurrentLocation");
    let defaultValue = this.getValue("DefaultValue");
    if (!UseCurrentLocation && typeof defaultValue === "object") {
      var isEmptyObj = this.validateDefaultValue(defaultValue);
      if (isEmptyObj) {
        errors.push("DefaultValue");
      }
    }
    return errors;
  }
}

GeolocationField.setFieldTypes({
  DefaultValue: FieldTypes.object,
  UseCurrentLocation: FieldTypes.boolean,
  AllowEdit: FieldTypes.boolean
});

GeolocationField.setOneToManyList(["Field::Expression"]);

export class ScannerField extends Field {}

ScannerField.setFieldTypes({
  ScanFromStorage: FieldTypes.boolean
});

ScannerField.setOneToManyList(["FieldValidation::Criteria", "Field::Event"]);

registerFieldModels();
